import React from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const SpeakerCard = ({ speaker, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.05 }}
      className="group"
    >
      <div className="bg-white dark:bg-slate-900/40 rounded-[2.5rem] border border-slate-100 dark:border-white/10 overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500">
        <div className="relative aspect-square overflow-hidden m-3 rounded-[2rem]">
          <img 
            src={speaker.image} 
            alt={speaker.name}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
          />
        </div>
        <div className="p-6 pt-2">
          <div className="flex flex-col">
            <h3 className="text-lg font-black text-slate-900 dark:text-white leading-tight">
              {speaker.name}
              <span className="block text-[10px] font-bold text-slate-400 mt-0.5 uppercase">{speaker.degree}</span>
            </h3>
            <div className="h-px w-8 bg-slate-100 dark:bg-white/10 my-3" />
            <p className="text-[11px] text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">{speaker.title}</p>
            <div className="mt-3 flex items-center gap-2">
              <div className="h-1.5 w-1.5 rounded-full bg-blue-600" />
              <span className="text-[9px] font-black text-blue-600 dark:text-blue-400 uppercase tracking-[0.15em]">{speaker.topic}</span>
            </div>
          </div>
          <button className="mt-6 w-full py-3 rounded-xl border border-slate-50 dark:border-white/5 text-[9px] font-black uppercase tracking-widest text-slate-400 group-hover:text-blue-600 transition-all flex items-center justify-center gap-2">
            View Profile <ExternalLink size={12} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default SpeakerCard;